/**
 * Default brand monogram — renders the official Vigilant Entities
 * V·E mark (purple + brushed-silver, transparent background).
 *
 * Lives at `/vigilant-mark.png` in /public so it's served as a
 * static asset (no bundler hashing). Component kept under the
 * `DefaultMonogramSVG` name for backwards-compatibility with every
 * import site; semantically it's now an <img>, not an <svg>.
 *
 * Tenants with their own `branding.logo_url` set still bypass this
 * component entirely (handled inside <LogoMark/>). So this only
 * renders for the platform's own pages (Vigilant Entities chrome).
 */
import React from 'react';

export default function DefaultMonogramSVG({ className = '', style }) {
  return (
    <img
      src="/vigilant-mark.png"
      alt="Vigilant Entities"
      className={`${className} object-contain select-none`}
      style={style}
      draggable={false}
      aria-hidden="true"
    />
  );
}
